import PageHero from "@/components/base/PageHero";
import ScrollReveal from "@/components/base/ScrollReveal";
import SectionHeading from "@/components/base/SectionHeading";
import CompanySubNav from "@/pages/company/components/CompanySubNav";
import { BUSINESSES } from "@/constants/site";

const OVERVIEW_ROWS = [
  { label: "法人名", value: "REVRA Group" },
  { label: "代表者名", value: "河出 享一郎" },
  { label: "住所", value: "未定" },
  { label: "設立年月日", value: "2026年内目処" },
];

export default function CompanyOverview() {
  return (
    <div className="w-full bg-background-50">
      <PageHero
        en="OVERVIEW"
        ja="会社概要"
        crumbs={[{ label: "企業情報", path: "/company" }, { label: "会社概要" }]}
      />
      <CompanySubNav />

      <section className="w-full py-20 md:py-28">
        <div className="mx-auto w-full max-w-7xl px-6 md:px-12 lg:px-20">
          <ScrollReveal>
            <SectionHeading label="会社概要" en="Company" />
          </ScrollReveal>

          <ScrollReveal delay={100}>
            <dl className="mt-14 grid grid-cols-1 border-t border-background-300/70 md:grid-cols-[220px_1fr]">
              {OVERVIEW_ROWS.map((row) => (
                <div
                  key={row.label}
                  className="contents"
                >
                  <dt className="border-b border-background-300/70 bg-background-100 px-6 py-5 font-body text-sm tracking-[0.08em] text-foreground-700 md:px-8">
                    {row.label}
                  </dt>
                  <dd className="border-b border-background-300/70 px-6 py-5 font-body text-sm text-foreground-950 md:px-8">
                    {row.value}
                  </dd>
                </div>
              ))}
            </dl>
          </ScrollReveal>

          <ScrollReveal delay={150}>
            <div className="mt-20">
              <SectionHeading label="業務内容" en="Business" />
              <div className="mt-12 flex flex-col border-t border-background-300/70">
                {BUSINESSES.map((business) => (
                  <div
                    key={business.no}
                    className="grid grid-cols-1 gap-4 border-b border-background-300/70 py-8 md:grid-cols-[120px_1fr] md:gap-10 md:py-10"
                  >
                    <span className="font-label text-2xl tracking-[0.1em] text-accent-600">
                      {business.no}
                    </span>
                    <div>
                      <div className="flex flex-wrap items-baseline gap-4">
                        <h3 className="font-heading text-lg font-medium tracking-[0.04em] text-foreground-950">
                          {business.title}
                        </h3>
                        <span className="font-label text-[11px] tracking-[0.26em] text-secondary-500">
                          {business.en}
                        </span>
                      </div>
                      <p className="mt-3 font-body text-sm leading-[2] text-foreground-700">
                        {business.desc}
                      </p>
                      <p className="mt-2 font-body text-sm leading-[2] text-foreground-950">
                        {business.value}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </ScrollReveal>
        </div>
      </section>
    </div>
  );
}